export default __webpack_public_path__ + "static/media/Learning.db11c05c.svg";